@import 'styles/mixins';
@import 'styles/variables';

.articleRow {
  align-items: center;
  display: flex;
  padding: 10px 8px;
  opacity: 0.5;
  cursor: default;

  @include for-phone-only {
    justify-content: space-between;
  }

  .titleColumn {
    display: flex;
    align-items: center;
    flex: 0 0 60%;
    min-width: 0;

    .title {
      @include md-regular;

      color: $grey-90;
      margin-left: 9px;
      @include line-clamp(1);
      max-width: 80%;
    }
    .folderIcon {
      margin-left: 28px;
    }
  }

  .handbookIcon > path:first-child {
    fill: $gold-50;
  }

  .articleIcon > path:nth-child(2) {
    fill: $blue-40;
  }

  .column {
    @include ui-sm-text;

    color: $gray-40;
    flex: 0 0 20%;
    min-width: 0;
  }
}

.narrowTooltip {
  width: 110px;
  opacity: 0.5;
}

.folderIcon {
  align-items: center;
  display: flex;
  height: 16px;

  > * {
    align-items: center;
    display: flex;
    height: 16px;
  }
}
